export default __webpack_public_path__ + "static/background-3f1563340824e818a0f8e95cf1118f79.png";